module.exports = __webpack_public_path__ + "static/media/Icons_Public_Document_Centre_School_Association.ac7dabb9.png";